import { useEffect, useState, useRef } from 'react';
import { Loader } from '@mantine/core';
import { useTranslation } from '../../context/TranslationContext';
import paymentMethodsService from '../../services/payment_methods';

const BRAND_ICONS = {
  visa: '💳', mastercard: '💳', amex: '💳', discover: '💳', Unionpay: '💳', jcb: '💳', unknown: '💳',
};

export default function SavedCardList({ selectedCardId, onSelectCard, onCardsLoaded, refreshTrigger }) {
  const { t } = useTranslation();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const onCardsLoadedRef = useRef(onCardsLoaded);
  onCardsLoadedRef.current = onCardsLoaded;

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const data = await paymentMethodsService.getPaymentMethods();
        if (!cancelled) {
          setCards(data);
          setError(null);
          if (onCardsLoadedRef.current) onCardsLoadedRef.current(data);
        }
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [refreshTrigger]);

  if (loading) {
    return (
      <div role="status" aria-live="polite" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0' }}>
        <Loader size="sm" />
        <span>{t('loadingCards', 'Loading cards…')}</span>
      </div>
    );
  }

  if (error) {
    return <div role="alert" style={{ color: 'red', fontSize: '0.9em' }}>{error}</div>;
  }

  if (cards.length === 0) {
    return null;
  }

  return (
    <div className="saved-cards-list" role="radiogroup" aria-label={t('savedCards', 'Saved Cards')}>
      {cards.map(card => (
        <label
          key={card.id}
          className={`address-radio${selectedCardId === card.id ? ' selected' : ''}`}
        >
          <input
            type="radio"
            name="savedCard"
            value={card.id}
            checked={selectedCardId === card.id}
            onChange={() => onSelectCard(card.id)}
            aria-label={`${card.brand?.toUpperCase()} card ending in ${card.last4}`}
          />
          <span>
            <strong>{(BRAND_ICONS[card.brand] || '')} {card.brand?.toUpperCase()} •••• {card.last4}</strong>
            <span style={{ marginLeft: 8, color: '#666', fontSize: '0.9em' }}>
              {String(card.exp_month).padStart(2, '0')}/{String(card.exp_year).slice(-2)}
            </span>
          </span>
        </label>
      ))}
    </div>
  );
}
